import { selectCartEntries } from './cart/cart.selectors';

export const orderingSelectors = {
  // Cart selectors
  selectCartEntries,
};
